import api from "../laravelAxiosClient";
import {
  CalculerPrixPayload,
  CalculerPrixResult,
  CreatePetiteAnnoncePayload,
  CreatePetiteAnnonceResult,
  CreatePetiteAnnonceStripeSessionResult,
  CreationDataResult,
  DeletePetiteAnnonceResult,
  PetiteAnnonceResult,
  PetitesAnnoncesResult,
} from "../interfaces/petites-annonces.interface";

export const petitesAnnoncesService = {
  findAll: async () => {
    const { data } = await api.get<PetitesAnnoncesResult>("/petites-annonces");
    return data;
  },
  findById: async (id: string) => {
    const { data } = await api.get<PetiteAnnonceResult>(`/petites-annonces/${id}`);
    return data;
  },
  getCreationData: async () => {
    const { data } = await api.get<CreationDataResult>("/petites-annonces/creation-data");
    return data;
  },
  create: async (payload: CreatePetiteAnnoncePayload) => {
    const { data } = await api.post<CreatePetiteAnnonceResult>("/petites-annonces", payload);
    return data;
  },
  createStripeSession: async (id: string) => {
    const { data } = await api.post<CreatePetiteAnnonceStripeSessionResult>(
      `/petites-annonces/${id}/stripe-session`,
    );
    return data;
  },
  remove: async (id: string) => {
    const { data } = await api.delete<DeletePetiteAnnonceResult>(`/petites-annonces/${id}`);
    return data;
  },
  calculerPrix: async (payload: CalculerPrixPayload) => {
    const { data } = await api.post<CalculerPrixResult>("/petites-annonces/calculer-prix", payload);
    return data;
  },
};
